import { purchaseState } from './purchase.state';
import { purchaseActions } from './purchase.action';
import { purchaseMutations } from './purchase.mutation';

export default {
  namespaced: true,
  state: purchaseState,
  getters: {},
  actions: purchaseActions,
  mutations: purchaseMutations,
};
